import { render, staticRenderFns } from "./opxDrawings.vue?vue&type=template&id=27e53b76&scoped=true&"
import script from "./opxDrawings.vue?vue&type=script&lang=js&"
export * from "./opxDrawings.vue?vue&type=script&lang=js&"
import style0 from "./opxDrawings.vue?vue&type=style&index=0&id=27e53b76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e53b76",
  null
  
)

export default component.exports